import React from 'react';
import empty_image_insta from './insta_icons_tasks/empty_image_insta.svg'
import message_square_insta_android from '../custom_icons/message_square.svg'
import chevron_next_insta_android from '../custom_icons/chevron_next.svg'
import BaseEarnTask from './BaseEarnTask';
import qs from 'querystring'
import {getRequestParams, isFirstCommentCompleted, setFirstCommentCompleted} from './utils_android/CookieHelper'
import { ReCaptcha } from 'react-recaptcha-v3'
import { getTimestampToken, getRequestUrl, getHttpParams } from '../../utils/Utils';
import { getLocalizedStrings } from '../../utils/LocalizedStrings';
import FirstCommentTooltip from '../tooltips/FirstCommentTooltip';
var strings = getLocalizedStrings()
class ExtraComment extends BaseEarnTask {
    constructor(props){
        super(props)
        this.state = {
            currentDescription : "",
            isUpdateCaptcha : false,
            isShowError : false,
            isShowCommentTooltip : false,
            isImgError : false
        }
        this.startTaskTime = -1
        window.extraComment = this
        this.toogleFirstComment = this.toogleFirstComment.bind(this);
        this.toogleImgError = this.toogleImgError.bind(this);
    }
    onResume(){
        this.setState({isUpdateCaptcha : true})
        console.log("onResume comment")
    }
    toogleImgError(){
        this.setState({isImgError : true})
    }
    verifyCallback = (recaptchaToken) => {
        this.setState({isUpdateCaptcha : false})

        if (this.startTaskTime != -1){
            
            var currentTime = new Date().getTime()
            if (currentTime - 300 >= this.startTaskTime){
                this.props.showLoader()
                this.instaComment(recaptchaToken)
            }
        }
    }
    doTask = () => {
        if (isFirstCommentCompleted()){
            this.startTaskTime = new Date().getTime()
            this.openUrl(this.props.currentExtraOrder.insta_url, 2)
        } else {
            setFirstCommentCompleted()
            this.setState({isShowCommentTooltip : true})
        }
        
    }
    instaComment = (recaptchaToken) => {
        this.setState({isShowError : false})
        var params = getRequestParams();
        params.timestamp = recaptchaToken
        params._id = this.props.currentExtraOrder.order._id;
        params.photo_id = this.props.currentExtraOrder.order.media_id;
        params.text = ""
        fetch(getRequestUrl() + "instaComment", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            if (responseData.response == 1 || responseData.response == 2) {
                this.props.loadNextOrder()
                this.props.taskCompleted()
            } else {
                this.setState({isShowError : true})
                this.errorTask()
            }
            this.startTaskTime = -1
            console.log("instaComment" + JSON.stringify(responseData))
        })
    }
    skip = () => {
        this.skipOrder(false, this.props.currentExtraOrder.order._id)
    }
    toogleFirstComment(){
        this.setState({isShowCommentTooltip : !this.state.isShowCommentTooltip})
        this.doTask()
    }
    render() {
        return (
            <div className="rate-content__item">
                    <div className="photo_task_container">
                        <img width="64" height="64" className="placeholder_task icon_64"
                            src={empty_image_insta} alt=""/>
                        <img style={this.state.isImgError ? {opacity : '0'} : {}} onError={this.toogleImgError} className="image_task_holder" src={this.props.currentExtraOrder.userInfo ? this.getSource(this.props.currentExtraOrder.userInfo.items[0]) : this.props.currentExtraOrder.order.photo_url}
                            alt="" width="360" height="360"/>
                        <img onClick={this.skip} src={chevron_next_insta_android} className="arrows__item arrows__item_next arrow_item_follower"></img>
                        {/* {!this.state.isShowCommentTooltip && <p onClick={this.appealClicked} className="appeal_text appeal_text_bg">{strings.APPEAL}</p>} */}
                    </div>


                    <div className="rate-content__actions">
                        {this.state.isShowError && <p className="block_account">{strings.ERROR_LIKE_1}<br/>{strings.ERROR_LIKE_2}</p>}
                        <div onClick={this.doTask} className="btn-follow top_10">
                            <img className="btn_task_icon" src={message_square_insta_android} alt=""/>
                           {strings.WRITE_COMMENT_BUTTON}
                        </div>
                        {this.state.isShowCommentTooltip && <FirstCommentTooltip toogleFirstComment={this.toogleFirstComment}/>}
                        <div className="coins_rub_lashka rub_plashka">
                            <span className="subscribe_follow_reward right_4">+{this.props.reward} {strings.COIN_2}</span>
                            <span className="subscribe_follow_reward left_4">+{this.props.currentExtraOrder.earn_money}₽</span>
                        </div>
                    </div>
                    {this.state.isUpdateCaptcha && <ReCaptcha
                        sitekey={getTimestampToken()}
                        action='homepage'
                        verifyCallback={this.verifyCallback}/>
                    } 
            </div>
        );
    }
}
export default ExtraComment;
